<template>
  <div class="comps">
    <span class="phead">NO COMPETITIONS ARE AVAILIBLE RIGHT NOW.</span>
    <!-- <hr />
    <div class="btn-group" id="btngroup">
        <button>Business</button>
        <button>Art</button>
        <button>Gaming</button>
        <button>Graphic Design</button>
        <button>Dance</button>
        <button>Book Quiz</button>
        <button>Creative Writing</button>
        <button>Photography</button>
    </div>
    <div class="competition">
        <img id="compBanner" width="525px" />
        <div style="text-align: center;">
            <span id="compName" style="font-size: 50px" class="phead">Competition Name</span>
            <p id="compDesc" style="font-size: 24px; max-width: 600px">This is the description area for each competition. Keep in mind that this will be absolutely huge in some competition descriptions</p>
            <a href="#" target="_blank"><button id="register">Register</button></a>
        </div>
    </div>   -->
  </div>
</template>

<script>
import { competitions } from '@/assets/competitions.json'

export default {
    mounted() {
        let btngroup = document.getElementById("btngroup")

        for (let i = 0; i < btngroup.childElementCount; i++) {
            btngroup.children[i].addEventListener('click', ()=>{
                showComp(i)
            })
        }
        let compBanner = document.getElementById("compBanner")
        let compName = document.getElementById("compName")
        let compDesc = document.getElementById("compDesc")
        let registerBtn = document.getElementById("register")

        function showComp(i){

            // ------------ CSS -------------------------
            // remove active class from all elements 
            for (let i = 0; i < btngroup.childElementCount; i++) { 
                btngroup.children[i].classList.remove("active")
            }
            
            // add active class to selected element 
            btngroup.children[parseInt(i)].classList.add("active")

            // ------------- Actual code ------------------
            if(i == 2) {
                let btn = document.createElement('a')
                btn.innerHTML = `
                <a id="discord" target="_blank" href="https://discord.com/invite/DBKY5wxkwQ"><button class="discordbtn">Discord</button></a>
                `
                registerBtn.parentElement.append(btn)
            } else {
                if(document.getElementById('discord')) {
                    document.getElementById("discord").remove();
                }
            }
            compBanner.src = competitions[i][0]
            compName.innerText = competitions[i][1]
            compDesc.innerHTML = competitions[i][2]
            registerBtn.parentElement.setAttribute("href", competitions[i][3])

        }

        showComp(0)
    },
}
</script>